import CityPageSEO from "@/hooks/usePageSEO";
import SmyrnaHeroSection from "./components/HeroSection";
import SmyrnaStickyNav from "./components/StickyNav";
import SmyrnaProcessingTimeSection from "./components/ProcessingTimeSection";
import SmyrnaServicesSection from "./components/ServicesSection";
import SmyrnaLocalAreaSection from "./components/LocalAreaSection";
import SmyrnaTestimonialsSection from "./components/TestimonialsSection";
import SmyrnaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SmyrnaComparisonSection from "./components/ComparisonSection";
import SmyrnaMistakesSection from "./components/MistakesSection";
import SmyrnaHowItWorksSection from "./components/HowItWorksSection";
import SmyrnaFAQSection, { faqs } from "./components/FAQSection";
import SmyrnaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SmyrnaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function SmyrnaPage() {
  return (
    <div className="font-sans">
      <CityPageSEO config={{
        cityName: "Smyrna",
        route: "/cities/smyrna",
        description: "Emergency and expedited passport services in Smyrna, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Cobb County and northwest metro Atlanta travelers. Get your emergency passport fast!",
        geoPlacename: "Smyrna, Georgia",
        geoPosition: "33.8839;-84.5144",
        keywords: "expedited passport, emergency passport, Smyrna passport, same day passport Smyrna, fast passport Georgia, Cobb County passport",
        faqs,
      }} />
      <SmyrnaHeroSection />
      <SmyrnaStickyNav />
      <SmyrnaProcessingTimeSection />
      <SmyrnaLocalAreaSection />
      <SmyrnaServicesSection />
      <SmyrnaTestimonialsSection />
      <SmyrnaAcceptanceFacilitiesSection />
      <SmyrnaComparisonSection />
      <SmyrnaMistakesSection />
      <SmyrnaHowItWorksSection />
      <SmyrnaFAQSection />
      <SmyrnaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/smyrna" state="GA" />
      <SmyrnaFinalCTA />
    </div>
  );
}